import type { IFilterComp, IMultiFilterComp, ISetFilter } from "ag-grid-enterprise";
import type { GridApi } from "~/components/grid/AgGrid";

const refreshFilter = (filter: IFilterComp | IMultiFilterComp | ISetFilter): void => {
	if ("refreshFilterValues" in filter && typeof filter.refreshFilterValues === "function") {
		filter.refreshFilterValues();
	} else if ("getChildFilterInstance" in filter) {
		for (let index = 0; ; index++) {
			const child = filter.getChildFilterInstance(index);
			if (!child) break;
			refreshFilter(child);
		}
	}
};

const refreshColumnSetFilterValues = async (api: GridApi, colId: string): Promise<void> => {
	if (api.isDestroyed()) return;
	const filter = await api.getColumnFilterInstance<IFilterComp | IMultiFilterComp>(colId);
	if (filter && !api.isDestroyed()) refreshFilter(filter);
};

export default refreshColumnSetFilterValues;
